// extracted by mini-css-extract-plugin
module.exports = {"shows":"shows-module--shows--3m-JA","hero":"shows-module--hero--1L451"};